export default __webpack_public_path__ + "open-roll-side-fix.jpg";